import { CSSProperties, FunctionComponent, ReactNode } from 'react';
import { Separator as V4Separator } from 'react-resizable-panels';

export interface ISeparatorProps {
  id?: string;
  className?: string;
  style?: CSSProperties;
  disabled?: boolean;
  // v4 added "double-click the separator resets its panel to the default size". Disable it by
  // default to preserve the v3 behaviour (no implicit size reset on double-click).
  disableDoubleClick?: boolean;
  children?: ReactNode;
}

// Compatibility wrapper over react-resizable-panels v4 `Separator` — keeps the new double-click
// reset behaviour off by default so resize handles behave as they did before the migration.
export const Separator: FunctionComponent<ISeparatorProps> = ({ disableDoubleClick = true, children, ...rest }) => (
  <V4Separator disableDoubleClick={disableDoubleClick} {...rest}>
    {children}
  </V4Separator>
);
